module.exports = __webpack_public_path__ + "supplier/img/clt_logo.d5108490.png";